import Marquee from "react-fast-marquee";
import { CHAINS } from "../../lib/content";

export const ChainsMarquee = () => (
  <section className="border-y border-slate-200/70 bg-white py-10" data-testid="chains-marquee">
    <p className="overline mb-6 text-center">One integration · Every major chain</p>
    <div className="marquee-fade">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {CHAINS.map((c) => (
          <span key={c} className="font-heading mx-8 text-xl font-medium tracking-tight text-slate-300 transition-colors duration-300 hover:text-[#3B5FE8] sm:mx-12 sm:text-2xl">
            {c}
          </span>
        ))}
      </Marquee>
    </div>
  </section>
);
